



































































































































































































































































































































	import {
		Component,
		Prop,
	} from "vue-property-decorator"
	import AbpBase from "@/lib/abpbase"
	import {
		SavePatPreTemp
	} from "@/api/patient"
	import {
		GetListByCode
	} from "@/api/configureDictionary"
	import {
		GetPatientVascularAccessList
	} from "@/api/vascularAccess"
	import {GetAntiMedicineList} from "@/api/systemBasic"
	import {GetAntiMedicineListByType} from "@/api/dialysisProcess"
	import ConEdit from '@/views/dialysisProcess/waitRoom/conEdit'

	@Component({
		components:{ConEdit}
	})
	export default class AddOrEdit extends AbpBase {
		@Prop() value: boolean
		conEditShow = false
		/**
		 * this.addOrEditTempData = {
		 *		mode: 'add',
		 * 		name: name,
		 *		patient: this.patient
		 *	}
		 *
		 * */
		@Prop() data: any
		//耗材列表
		consList:any = {
			list:[]
		}
		async consBack(data:any){
			this.model.conItems = data
		}
		model: any = {
			dialysateconcNa: null,
			anticoagulantAdd: null,
			dryWeight: null,
			offset: null,
			anticoagulantFirst: null,
			anticoagulationUnit: 'U',
			anticoagulationWays: 0,
			dialysateFlowRate: 500,
			dialysateTemperature: 37.5,
			dialysateconcCa: null,
			dialysateconcHco3: null,
			dialysateconcMg: null,
			dialysateconcGlucose: null,
			dialysateconcCl: null,
			dialysateconcAc: null,
			bloodVelocity: 240,
			antiItems: [],
			dialysisHour: 4
		}

		addAntiWays() {
			let flag = true
			this.model.antiItems.forEach((item: any) => {
				if (this.abtiWaysModel.antiWays == item.antiWays) {
					flag = false
				}
			});
			if (!flag) {
				this.$Message.info("抗凝方式只可选择一种")
				return false
			}
			// todo
			// if (!this.abtiWaysModel.antiFirstUnit) {
			// 	this.$Message.info('请选择单位！')
			// 	return
			// }
			let data = Object.assign({}, this.abtiWaysModel)
			this.model.antiItems.push(data)
			console.log(this.model.antiItems)
			//清空
			this.abtiWaysModel.medId = null
			this.abtiWaysModel.antiFirstDose = null
			this.abtiWaysModel.antiAddDose = null
			this.abtiWaysModel.dose = null
			this.abtiWaysModel.gaMedId = null
			this.abtiWaysModel.gaDose = null
			this.abtiWaysModel.normalSalineMedId = null
			this.abtiWaysModel.normalSalineDose = null
			this.abtiWaysModel.pumpDose = null
		}

		//抗凝药品
		antiWaysDrugs: any = []
		//抗凝model
		abtiWaysModel: any = {
			antiWays: null,
			// 抗凝方式（数据字典对应的Id）
			medId: null,
			// 抗凝剂对应药品id
			antiFirstDose: null,
			// 首剂
			antiFirstUnit: null,
			// 首剂单位
			antiAddDose: null,
			// 追加/小时
			dose: null,
			// 枸橼酸剂量(ml/h)
			gaMedId: null,
			// 钙剂药品Id
			gaDose: null,
			// 钙剂剂量(ML)
			normalSalineMedId: null,
			// 生理盐水药品Id
			normalSalineDose: null,
			// 生理盐水剂量（ML）
			pumpDose: null,
			// 泵 入( ml/h)
		}
		//所有抗凝药品
		antiWaysDrugAll: any = []
		antiWaysType = ''

		//抗凝模式
		antiWaysChange1() {
			//清空
			this.abtiWaysModel.medId = null
			this.abtiWaysModel.antiFirstDose = null
			this.abtiWaysModel.antiAddDose = null
			this.abtiWaysModel.dose = null
			this.abtiWaysModel.gaMedId = null
			this.abtiWaysModel.gaDose = null
			this.abtiWaysModel.normalSalineMedId = null
			this.abtiWaysModel.normalSalineDose = null
			this.abtiWaysModel.pumpDose = null
			//抗凝方式名称
			this.antiWaysDrugAll = []
			this.anticoagulationWayss.forEach((item: any) => {
				if (this.abtiWaysModel.antiWays == item.id) {
					this.antiWaysDrugs = item.items || []
					this.antiWaysType = item.alSubclass
					if (this.antiWaysDrugs[0]) {
						this.abtiWaysModel.antiFirstUnit = this.antiWaysDrugs[0].dosageUnit
					} else {
						this.abtiWaysModel.antiFirstUnit = ""
					}
				}
				if (item.items) {
					this.antiWaysDrugAll.push(...item.items)
				}
			})
			console.log(this.antiWaysDrugAll)
			//默认加载第一条
			if (this.antiWaysType != '无肝素') {
				this.abtiWaysModel.medId = this.antiWaysDrugs[0].anticoagulateMedId
			}
		}
		klSelect(id:number){
			// TODO
			// anticoagulateMedId  medicineModel
			this.antiWaysDrugs.forEach((item:any) => {
				if (item.anticoagulateMedId === id) {
					this.abtiWaysModel.antiFirstUnit = item.dosageUnit
				}
			})
		}
		antiWaysColumn: any = []
		//获取钙剂和生理盐水
		gaMedOptions: any = []
		normalSalineMedOptions: any = []

		async getAntiMedicineListByType() {
			let res = await GetAntiMedicineListByType({medType: 1078})
			this.gaMedOptions = res
			let res1 = await GetAntiMedicineListByType({medType: 1116})
			this.normalSalineMedOptions = res1
		}

		// 通路类型 下标
		vaTypeIndex = 0
		// 通路集合
		vas: any = []
		//患者类型
		patientType = 0
		//选中的透析模式下标
		dialysisWay = 0
		//抗凝方式集合 来自配置项字典
		anticoagulationWayss: any = []
		//治疗方式(透析模式)集合 来自配置项字典
		dialysisWays = []
		//浓度颜色
		caColor = ''
		medIds: any = {}
		gaMedOptions: any = []
		slys: any = []

		async created() {
			await this.getSelect()
			// await this.getAntiMedicineListByType()
			this.antiWaysColumn = [
				{
					key: 'antiWaysType',
					title: '抗凝方式',
					render: (h: any, params: any) => {
						return h('span', this.anticoagulationWayss.find((item: any) => {
							return item.id == params.row.antiWays
						}).alSubclass)
					}
				}, {
					key: 'medName',
					title: '抗凝药品',
					render: (h: any, params: any) => {
						return h('span', params.row.medId
							? this.antiWaysDrugAll.find((item: any) => {
								return item.anticoagulateMedId == params.row.medId
							}).anticoagulateMedName + '(' +
							this.antiWaysDrugAll.find((item: any) => {
								return item.anticoagulateMedId == params.row.medId
							}).medicineModel + ')'
							: '')
					}
				}, {
					key: 'antiFirstDose',
					title: '首剂',
				}, {
					key: 'antiFirstUnit',
					title: '首剂单位',
				}, {
					key: 'antiAddDose',
					title: '追加/小时',
				}, {
					key: 'dose',
					title: '枸橼酸剂量(ml/h)',
				}, {
					key: 'gaMedName',
					title: '钙剂药品',
					render: (h: any, params: any) => {
						return h('span', params.row.gaMedId ? this.gaMedOptions.find((item: any) => {
							return item.id == params.row.gaMedId
						}).medicineName : '')
					}
				}, {
					key: 'gaDose',
					title: '钙剂剂量',
				}, {
					key: 'normalSalineMedName',
					title: '生理盐水药品',
					render: (h: any, params: any) => {
						return h('span', params.row.normalSalineMedId ? this.normalSalineMedOptions.find((item: any) => {
							return item.id == params.row.normalSalineMedId
						}).anticoagulateMedName : '')
					}
				}, {
					key: 'normalSalineDose',
					title: '生理盐水剂量',
				}, {
					key: 'pumpDose',
					title: '泵 入',
				}, {
					title: this.L('Actions'),
					key: 'Actions',
					width: 70,
					render: (h: any, params: any) => {
						return h('div', [
							h('Button', {
								props: {
									type: 'error',
									size: 'small'
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.antiDelete(params.add)
									}
								}
							}, '删除'),
						])
					}
				}
			]
			console.log(this.data.item)
			if (this.data.mode === 'edit') {
				this.model = this.data.item
				this.model.antiItems = this.data.item.antis
				this.consList = {
					list: this.model.conItems
				}
				this.patientType = this.model.patientType
				this.dialysisWays.forEach((item:any,index:number) => {
					if (item.text === this.model.dialysisWay) {
						this.dialysisWay = index
					}
				})
				this.txyEdit(this.model.dialysateconcCa)
				this.vas.forEach((item:any,index:number) => {
					if (item.id === this.model.patVaId) {
						this.vaTypeIndex = index
					}
				})
			}
			this.conEditShow = true
		}
		antiDelete(index:any){
			this.model.antiItems.splice(index, 1);
		}

		addKl() {
			this.model.antiItems.push({
				antiWaysName: '', //抗凝方式名称
				antiWays: null,//抗凝方式（数据字典对应的Id）
				medId: 0,//抗凝剂对应药品id
				antiFirstDose: null,//首剂
				antiFirstUnit: 'U',//首剂单位
				antiAddDose: null,//追加/小时
				dose: null,//枸橼酸剂量(ml/h)
				gaMedId: null,//钙剂药品Id
				gaDose: null,//钙剂剂量(ML)
				normalSalineMedId: null,//生理盐水药品Id
				normalSalineDose: null,//生理盐水剂量（ML）
				pumpDose: null,//泵 入( ml/h)
			})
		}

		async save() {
			this.model.patientType = this.patientType
			this.model.patientId = this.data.patient.id
			this.model.patVaId = this.vas[this.vaTypeIndex].id
			let res = await SavePatPreTemp(this.model)
			if (res.status === 1) {
				this.$emit('save-success')
			}
// 			(this.$refs.form as any).validate(async (valid: boolean) => {
// 				if (valid) {
//
// 				}
// 			})
		}

		/**
		 * 抗凝方式下拉选择时
		 * selectedKL 赋值来判断抗凝所属
		 * */
		antiWaysChange(val: any, itemId: number) {
			this.anticoagulationWayss.forEach((item: any) => {
				if (item.id === itemId) {
					val.antiWaysName = item.alSubclass
				}
			})
			val.medId = null
		}
		txyEdit(txy:any) {
			switch (txy) {

				case 1.75:
					this.caColor = 'red'

					break;
				case 1.50:
					this.caColor = '#0f0'

					break
				case 1.25:
					this.caColor = 'rgb(223, 225, 19)'

					break;
				case 1.35:
					this.caColor = 'white'
					break;
				default:
					break;
			}
		}
		/**
		 * 透析液下拉更改
		 *
		 */
		txyChange(txy: any) {
			switch (txy) {

				case 1.75:
					this.caColor = 'red'
					this.model.dialysateconcNa = 138
					this.model.dialysateconcK = 2
					this.model.dialysateconcHco3 = null
					this.model.dialysateconcMg = null
					this.model.dialysateconcGlucose = null
					this.model.dialysateconcCl = null
					this.model.dialysateconcAc = null
					break;
				case 1.50:
					this.caColor = '#0f0'
					this.model.dialysateconcNa = 138
					this.model.dialysateconcK = 2
					this.model.dialysateconcHco3 = 36
					this.model.dialysateconcMg = 3
					this.model.dialysateconcGlucose = 3
					this.model.dialysateconcCl = 3
					this.model.dialysateconcAc = 3
					break
				case 1.25:
					this.caColor = 'rgb(223, 225, 19)'
					this.model.dialysateconcNa = 138
					this.model.dialysateconcK = 2
					this.model.dialysateconcHco3 = null
					this.model.dialysateconcMg = null
					this.model.dialysateconcGlucose = null
					this.model.dialysateconcCl = null
					this.model.dialysateconcAc = null
					break;
				case 1.35:
					this.model.dialysateconcNa = null
					this.model.dialysateconcK = null
					this.model.dialysateconcHco3 = null
					this.model.dialysateconcMg = null
					this.model.dialysateconcGlucose = null
					this.model.dialysateconcCl = null
					this.model.dialysateconcAc = null
					break;
				default:
					break;
			}
		}

		selectDislysisWay(item: any) {
			this.dialysisWay = item
			this.model.dialysisWay = (this.dialysisWays[item] as any).text
		}

		get modalTitle() {
			return this.data.mode === 'add' ? '新增' : '编辑'
		}

		cancel() {
			this.$emit('input', false)
		}

		visibleChange(value: boolean) {
			if (!value) {
				this.$emit('input', value);
			}
		}

		rules = {}

		private async getSelect() {
			let res0 = await GetAntiMedicineListByType({medType: 1078})
			this.gaMedOptions = res0
			let ress = await GetAntiMedicineListByType({medType: 1116})
			this.normalSalineMedOptions = ress
			let resg = await GetAntiMedicineListByType({medType: 1106})
			this.gaMedOptions = resg
			// let ress = await GetAntiMedicineListByType({medType: 1116})
			// this.slys = ress
			let res = await GetAntiMedicineList({})
			this.anticoagulationWayss = res
			this.antiWaysDrugAll = []
			this.anticoagulationWayss.forEach((item: any) => {
				if (this.abtiWaysModel.antiWays == item.id) {
					this.antiWaysDrugs = item.items
					this.antiWaysType = item.alSubclass
				}
				if (item.items) {
					this.antiWaysDrugAll.push(...item.items)
				}
			})
			this.medIds = {}
			this.anticoagulationWayss.forEach((item: any) => {
				this.medIds[item.id] = item.items
			})
			let res1 = await GetListByCode({
				input: '025'
			})
			this.dialysisWays = res1
			this.model.dialysisWay = res1[0].text
			let res2 = await GetPatientVascularAccessList({
				PatientId: this.data.patient.id
			})
			this.vas = []
			res2.objects.forEach((item: any) => {
				if (!item.isOutCome) {
					this.vas.push(item)
				}
			})
			if (!this.vas.length) {
				this.$Modal.error({title:'提示',content:'请先维护该患者的血透通路！'})
			}
		}
	}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisPre/addOrEditTemp.vue